<template>
<div class="announced">
  <div class="tt">{{aTitle}}</div>
  <div class="date">{{h5Name}}</div>
  <div class="content" v-html="aContent"></div>
</div>
</template>

<script>
import utils from '../assets/js/utils'
export default {
  name: 'other',
  data () {
    return{
      list: [],
      queLst: [],
      aTitle: '',
      aContent: '',
      h5Name: '',
      id:utils.getUrlStr('id')
    }
  },
  mounted() {
    
    const formData = new FormData()
    formData.append('h5Type',5)
    formData.append('id', utils.getUrlStr('id'))
     this.$http({
        method: 'post',
        url: '/api/h5-rest/mine/html5List',
        data: formData
     }).then((res)=>{
      if(res.data.status === 200){
        if(res.data.data.appHtml5[0].contentType === 1){
          window.location.href = res.data.data.appHtml5[0].h5Content
        }else{
          this.aTitle = res.data.data.appHtml5[0].h5Title
          this.h5Name = res.data.data.appHtml5[0].h5Name
          this.aContent = res.data.data.appHtml5[0].h5Content
          document.title = this.aTitle
        }
      }else{

        alert(res.data.msg)
        }
      })
     console.log(this.list)
  },
  methods:{
    answer(item) {
      this.ansShow = true
      this.aTitle = item.h5Title
      this.aContent = item.h5Content
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.announced{
  padding: 0 0.75rem 1rem; background: #fff; overflow: hidden;
  .tt{color: #333333; font-size: 0.85rem; margin:0.5rem 0 0.25rem; text-align: center;}
  .date{font-size: 0.65rem; color: #999; margin:2rem 0 1rem; text-indent: 2em}
  .content{font-size: 0.75rem;line-height: 1.4rem;}
  img{max-width: 100%;}
}

</style>



// WEBPACK FOOTER //
// src/components/others.vue